import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ViewTemplate } from '../../../models/template.model';
import { NotificationService } from '../../../shared/services/notification.service';
import {
  SelectTemplateDialogInputData,
  SelectTemplateDialogComponent,
} from '../../../shared/select-template-dialog/select-template-dialog.component';
import { filter } from 'rxjs/operators';
import { ReportView } from '../../../models/report.model';
import { L10nTranslationService } from 'angular-l10n';

@Component({
  // eslint-disable-next-line
  selector: 'compare-actions-toolbar',
  templateUrl: './compare-actions-toolbar.component.html',
  styleUrls: ['./compare-actions-toolbar.component.scss'],
  standalone: false,
})
export class CompareActionsToolbarComponent {
  #templates: ViewTemplate[] = [];
  @Input() set templates(templates: ViewTemplate[]) {
    const shouldUpdate =
      this.#templates?.map?.(t => t.templateId).join() !== (templates ?? []).map?.(t => t.templateId).join();

    this.#templates = templates ?? [];

    if (shouldUpdate && this.#currentView != null) {
      this._updateTEmplateSelectionAndTitle();
    }
  }

  get templates() {
    return this.#templates;
  }

  #currentView: ReportView = null;
  @Input() set currentView(currentView: ReportView) {
    const isDifferentView = (prev: ReportView, next: ReportView) =>
      prev.templateId !== next.templateId || prev.id !== next.id;

    const shouldUpdate = currentView != null && isDifferentView(this.#currentView ?? ({} as never), currentView);

    this.#currentView = currentView;

    if (shouldUpdate && this.#templates?.length > 0) {
      this._updateTEmplateSelectionAndTitle();
    }
  }

  get currentView() {
    return this.#currentView;
  }

  @Input() reportData: Record<string, any>;

  @Input() recordList: Record<string, any>[];
  @Input() isUKFeaturesEnabled: boolean;
  @Output() templateChange: EventEmitter<number> = new EventEmitter<number>();

  public selectedTemplate: ViewTemplate;
  public selectedTemplateTitle: string;

  constructor(
    private notificationService: NotificationService,
    private translationService: L10nTranslationService
  ) {}
  // only apply changes when currentView & is different from prev value OR when templates changes

  private _updateTEmplateSelectionAndTitle() {
    this.selectedTemplate = this.#templates.find(temp => temp.templateId === this.currentView.templateId);
    this.selectedTemplateTitle = this.selectedTemplate
      ? `${this.selectedTemplate.templateName} ${this.translationService.translate('template.templateLbl')}`
      : '';
  }

  public openTemplates() {
    const options = { height: '90%', width: '90%', position: { top: '30px' } };
    const data: SelectTemplateDialogInputData = {
      templates: this.templates,
      reportId: this.reportData.reportId,
      selectedTemplateId: this.currentView.templateId,
      viewId: this.currentView.id,
    };
    this.notificationService
      .openDialog<number>(SelectTemplateDialogComponent, data, options)
      .pipe(filter((selectedTemplate: number) => selectedTemplate != null))
      .subscribe(selectedTemplateId => this.templateChange.emit(selectedTemplateId));
  }
}
